import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

// shadcn/ui Checkbox primitive (Radix base). Themed with the clinical design
// tokens — muted-teal brand fill when checked, desaturated error border via
// aria-invalid — so views never hardcode a raw <input type="checkbox">. The check
// glyph inherits currentColor (text-white token in the checked state).
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-[4px] border border-[color:var(--border-primary)] bg-[color:var(--bg-primary)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--focus-ring)] focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[color:var(--bg-brand-solid)] data-[state=checked]:bg-[color:var(--bg-brand-solid)] data-[state=checked]:text-[color:var(--text-white)] aria-[invalid=true]:border-[color:var(--border-error)] aria-[invalid=true]:focus-visible:ring-[color:var(--focus-ring-error)]",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
